import { DocumentEditor } from "@onlyoffice/document-editor-react";

export function OnlyOfficeEditor({
	token,
	options,
}: {
	token?: string;
	options?: Record<string, string | number>;
}) {
	const config = {
		...options,
		token,
	};

	return (
		<div style={{ height: "100svh" }}>
			<DocumentEditor
				id="onlyoffice-editor"
				documentServerUrl={import.meta.env.VITE_DOC_SERVER_URL}
				config={config}
				width="100%"
				height="100%"
			/>
		</div>
	);
}
